import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import PasswordResetForm from './PasswordResetForm';
import * as userActions from '../actions/UserActions';

class PasswordResetPage extends Component {
    render() {
        const {resetPassword, navigateToCardsPage} = this.props.userActions;

        return (
            <PasswordResetForm
                resetPassword={resetPassword}
                navigateToCardsPage={navigateToCardsPage}
            />
        );
    }
}

function mapStateToProps() {
    return {}
}

function mapDispatchToProps(dispatch) {
    return {
        userActions: bindActionCreators(userActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordResetPage)



// WEBPACK FOOTER //
// ./src/components/PasswordResetPage.js